var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"optiTANwrapper"},[_c('optitan-flicker',{attrs:{"id":"optiTANFlicker","tan-code":_vm.challengeValue,"speed":_vm.speed}})],1),_c('a-slider',{attrs:{"min":1,"max":500},model:{value:(_vm.speed),callback:function ($$v) {_vm.speed=$$v},expression:"speed"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }